<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  class="svg-facet-filter"
>
  <g fill="none" fill-rule="evenodd" stroke="none" stroke-width="1">
    <g fill="#1D1D1D" fill-rule="nonzero" transform="translate(-17 -251)">
      <g transform="translate(17 251)">
        <path
          id="Shape"
          d="M4.798 0C3.531 0 2.466.873 2.146 2.043H.717a.714.714 0 1 0 0 1.428h1.426c.318 1.173 1.386 2.05 2.655 2.05 1.257 0 2.316-.86 2.646-2.015l11.843-.035a.714.714 0 0 0 0-1.428l-11.824.034C7.155.89 6.078 0 4.798 0Zm0 1.429a1.32 1.32 0 0 1 1.333 1.33c0 .745-.589 1.333-1.333 1.333a1.32 1.32 0 0 1-1.33-1.332 1.32 1.32 0 0 1 1.33-1.331Zm7.632 5.474c-1.288 0-2.372.888-2.692 2.079H.718a.715.715 0 1 0 0 1.429H9.74c.32 1.19 1.403 2.08 2.69 2.08 1.286 0 2.369-.89 2.69-2.08h4.167a.714.714 0 0 0 0-1.429H15.12c-.32-1.19-1.404-2.079-2.692-2.079Zm0 1.429c.763 0 1.367.6 1.367 1.363s-.604 1.367-1.367 1.367a1.357 1.357 0 0 1-1.367-1.367c0-.763.603-1.363 1.367-1.363Zm-5.552 5.854c-1.286 0-2.37.889-2.69 2.079H.717a.715.715 0 1 0 0 1.428h3.468c.319 1.193 1.404 2.085 2.692 2.085 1.289 0 2.373-.892 2.692-2.085h9.717a.714.714 0 0 0 0-1.428H9.568c-.32-1.19-1.403-2.08-2.69-2.08Zm0 1.429c.764 0 1.368.603 1.368 1.367 0 .763-.604 1.367-1.368 1.367a1.357 1.357 0 0 1-1.367-1.367c0-.764.604-1.367 1.367-1.367Z"
        />
      </g>
    </g>
  </g>
</svg>
